// Maps a store-configured payment method name to its logo asset.
//
// Method names come from merchant config and are free-text ("BCA", "Bank BCA",
// "Mandiri VA"), so lookup runs two passes over the lowercased name:
//   1. whole name with non-alphanumerics dropped — catches "Shopee Pay"
//   2. any single word matching a brand — catches "Mandiri VA", "Bank BCA"
//
// Deliberately NOT prefix matching: "Danamon" starts with "dana" and would
// wrongly draw the DANA e-wallet logo. Word-level matching keeps them distinct.
//
// Unrecognised names return null and the caller falls back to a generic wallet
// icon — CIMB Niaga, Danamon and LinkAja have no asset yet, and merchants can
// type names we have never seen.

const LOGO_BY_METHOD: Record<string, string> = {
  bca: 'icon-bca.png',
  mandiri: 'icon-mandiri.png',
  bni: 'icon-bni.png',
  bri: 'icon-bri.png',
  permata: 'icon-permata.png',
  ovo: 'icon-ovo.png',
  shopeepay: 'icon-shopeepay.png',
  gopay: 'icon-gopay.png',
  dana: 'icon-dana.png',
  qris: 'icon-qris.png',
};

// Catch-all method name: instead of naming one channel, the buyer is pushed
// to the payment gateway's own chooser (Midtrans Snap with no
// enabled_payments restriction, or ESPAY's hosted page) and picks there.
// Meaningful only with an automated mode — a manual "Lainnya" has no
// account to transfer to. KEEP IN SYNC between web and prodpanel.
export const PAYMENT_METHOD_ANY = 'Lainnya';
export function isAnyPaymentMethod(method: string | undefined | null): boolean {
  return (method ?? '').trim().toLowerCase() === PAYMENT_METHOD_ANY.toLowerCase();
}

export function paymentLogoFor(method: string | undefined | null): string | null {
  if (!method) return null;
  const lower = method.toLowerCase();

  let file: string | undefined = LOGO_BY_METHOD[lower.replace(/[^a-z0-9]/g, '')];
  if (!file) {
    const word = lower.split(/[^a-z0-9]+/).find((w) => LOGO_BY_METHOD[w]);
    file = word ? (LOGO_BY_METHOD[word] as string) : undefined;
  }
  return file ? '/assets/payments/' + file : null;
}
